import React from "react";
import COPY from "@/content/v34Pages.json";

export function InlineCopy({ text }) {
  return text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("*") && part.endsWith("*")) return <em key={i}>{part.slice(1, -1)}</em>;
    return <React.Fragment key={i}>{part.replace(/`/g, "")}</React.Fragment>;
  });
}

export function copyBlocks(page) { return COPY[page]?.blocks || []; }

export function ApprovedCopy({ page, blocks, skipTitle = true, skip = [] }) {
  return (blocks || copyBlocks(page)).filter(b => !b.startsWith("**Important:** Existing directory fee plans") && !b.startsWith("*No independent breeder website database") && !b.startsWith("**Security note for developer:") && !(skipTitle && b.startsWith("# ")) && !skip.some(s => b.startsWith(s))).map((block, i) => {
    const heading = block.match(/^(#{1,3}) (.*?)(?: \{#([^}]+)\})?$/);
    if (heading) {
      const Tag = heading[1].length < 3 ? "h2" : "h3";
      return <Tag key={i} id={heading[3]} className={Tag === "h2" ? "font-display text-3xl md:text-4xl mt-12 mb-5 leading-tight" : "font-display text-xl md:text-2xl mt-7 mb-3"}>{heading[2]}</Tag>;
    }
    const lines = block.split("\n");
    if (lines.every(l => l.startsWith("- "))) return <ul key={i} className="list-disc pl-6 space-y-3 my-5 text-muted-foreground">{lines.map((l, n) => <li key={n}><InlineCopy text={l.slice(2)} /></li>)}</ul>;
    if (/^\*\*[^*]+\*\*$/.test(block)) {
      const text=block.slice(2,-2);
      if (text.endsWith("?") || text.startsWith("Step ")) return <h3 key={i} className="font-display text-xl md:text-2xl mt-7 mb-3">{text}</h3>;
      return null;
    }
    if (lines.every(l=>/^\d+\. /.test(l))) return <ol key={i} className="list-decimal pl-6 space-y-3 my-5 text-muted-foreground">{lines.map((l,n)=><li key={n}><InlineCopy text={l.replace(/^\d+\. /,"")} /></li>)}</ol>;
    return <p key={i} className="my-5 leading-relaxed text-muted-foreground whitespace-pre-line"><InlineCopy text={block} /></p>;
  });
}
